import {MNullable} from '../../Toolkit/Utils';
import {Request} from './RequestTypes';

export class Invoice {
    public static readonly PoNumberMaxLength = 20;
    public static readonly InvoiceMaxLength = 10;
    public static readonly NoteMaxLength = 1000;

    public id: number = 0;
    public parentId: string = '';
    public applicationSent: boolean = false;
    public poNumber: string = '';
    public workStart: MNullable<Date> = null;
    public workEnd: MNullable<Date> = null;
    public charge: number = 0;
    public invoiceNumber: string = '';
    public invoiced: boolean = false;
    public councilId: number = 0;
    public feeType: number = 0;
    public notes: string = '';
    public modifiedOn: MNullable<Date> = null;
    public modifiedBy: string ='';
};

export class InvoiceTracker {
    public invoice: Invoice = new Invoice();
    public request: Request = new Request();
}

export class InvoiceReply {
    public invoice: MNullable<Invoice> = null;
};

export class InvoiceMultiReply {
    public invoices: Invoice[] = [];
};

export class InvoiceTrackerReply {
    public invoices: InvoiceTracker[] = [];
}